import axios from "axios";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import Button from '@mui/material/Button';
import Config from "config"
import { handleErrors } from "common";
import { RETURN_REQUEST } from "constants";


function ConfirmationModelLoad(props) {
    const { confirmationDialogOpen, setConfirmationDialogOpen, confirmReturnId, setConfirmReturnId, pageContent, setPageContent, setIsLoading } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');

    const handleConfirmationDialogClose = () => {
        setConfirmationDialogOpen(false);
        setConfirmReturnId(0);
    };

    const handleConformationClose = () => {
        setIsLoading(true);
        toast.dismiss();
        axios.post(BASE + 'api/return/close', { returnID: confirmReturnId }, {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY,
            }
        }).then(function (response) {
            setIsLoading(false);

            if(response.status == 200)
            {
                if(response.data.status == 0)
                {
                    toast.error(t(response.data.message))
                }
                else {
                    toast.success(t(response.data.message))
                    setPageContent({ ...pageContent, status: RETURN_REQUEST.CLOSED });
                }
                setConfirmationDialogOpen(false);
            }
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }  

        }).catch(function (error) {
            setIsLoading(false);
            handleErrors(error, t, navigate);
            setConfirmationDialogOpen(false);
        });
       
    }

    return (
        <Dialog open={confirmationDialogOpen} onClose={handleConfirmationDialogClose}>
            <DialogTitle>{t("confirmCloseReturn")}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t("returnCloseMessage")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirmationDialogClose} color="primary">
                    {t("cancel")}
                </Button>
                <Button onClick={handleConformationClose} color="secondary">
                    {t("confirmClose")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmationModelLoad;
